
import {defineComponent} from 'vue';
import Header from '@/components/layout/Header.vue'; // @ is an alias to /src
import Footer from '@/components/layout/Footer.vue';
import GoogleTagManager from "@/components/misc/GoogleTagManager";

export default defineComponent({
    name: 'Home',
    components: {
        Header,
        Footer,
        GoogleTagManager
    }
});
